// HOOKS
import { useRef, useState, useEffect } from "react";

const DEFAULT_CLASSNAMES = {
  button: "relative",
  container:
    "rounded group bg-primary text-white hover:bg-secondary shadow shadow-secondary flex flex-col relative pr-4",
  containerLabel: "font-ubuntuMedium cursor-pointer p-2",
  dropdown:
    "border-animate rounded overflow-y-auto absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
  valueContainer:
    "absolute right-[1px] top-[1px] flex items-center justify-center text-center text-xs leading-none min-w-[20px] min-h-[20px] active:drop-shadow group-hover:bg-primary group-hover:text-white rounded-full text-white bg-secondary",
};

const DropdownButton = ({
  label = "",
  value = null,
  classNames = DEFAULT_CLASSNAMES,
  children,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  const handleClick = () => {
    setDropdown(!dropdown);
  };
  return (
    <button
      ref={ref}
      className={classNames?.button || DEFAULT_CLASSNAMES.button}
    >
      <div
        onClick={handleClick}
        ref={ref}
        className={classNames?.container || DEFAULT_CLASSNAMES.container}
      >
        <label
          className={
            classNames?.containerLabel || DEFAULT_CLASSNAMES.containerLabel
          }
        >
          {label}
        </label>
        {(value || value === 0) && (
          <div
            className={
              classNames?.valueContainer || DEFAULT_CLASSNAMES.valueContainer
            }
          >
            {value}
          </div>
        )}
      </div>

      <div
        ref={ref}
        className={`${classNames?.dropdown || DEFAULT_CLASSNAMES.dropdown} ${
          !dropdown ? "hidden" : ""
        }`}
      >
        {children}
      </div>
    </button>
  );
};

export default DropdownButton;
